import { DvirHistoryList } from "./DvirHistoryList";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";

export default {
  icon: ListAltOutlinedIcon,
  list: DvirHistoryList,
};
